import { render, staticRenderFns } from "./MultipleFaceDetector.vue?vue&type=template&id=a4f82a04&"
import script from "./MultipleFaceDetector.vue?vue&type=script&lang=js&"
export * from "./MultipleFaceDetector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports